var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"k-msg"},[_c('div',{staticClass:"k-m-title flex-b-c"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v(_vm._s(_vm.time))])]),_c('div',{staticClass:"k-m-describe"},[_vm._v(" "+_vm._s(_vm.describe)+" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }